/* eslint-disable */
// export const HOST = "http://localhost:8097";
// export const HOST = "https://musteri.hepsijet.com";
// export const HOST = "http://10.70.82.55:8097";
// https://musteri.hepsijet.com
// export const HOST = "http://10.70.82.29:8097";

let API_URL = window.location.origin;
if (process.env.NODE_ENV === 'development') {
  API_URL = 'http://localhost:8097';
}

export const HOST = API_URL;
export const AUTH = "user-login";
export const PUBLIC = "public";
export const API = "api";
export const DELAY = 5000; //ms



// WEBPACK FOOTER //
// ./src/constants.js